import type {BaseItemObject} from '@PosterWhiteboard/items/item/item.types';
import type {ItemEffectsObject} from '@PosterWhiteboard/classes/item-effects.class';
import type {RemoveVideoItemBackgroundObject} from '@PosterWhiteboard/items/video-item/remove-video-item-background.class';
import type {ItemCropObject} from '@PosterWhiteboard/classes/item-crop.class';
import type {UserVideoSource} from '@/libraries/user-video-library';

export const DEFAULT_VIDEO_EXTENSION = 'webm';

export interface VideoItemObject extends BaseItemObject {
  hashedFilename: string;
  duration: number;
  hasTransparency: boolean;
  frameRate: number;
  startTime: number;
  effects: ItemEffectsObject;
  endTime: number;
  volume: number;
  speed: number;
  videoSource: UserVideoSource;
  fileExtension: string;
  removeBackground: RemoveVideoItemBackgroundObject;
  cropData: ItemCropObject;
  timelineSpriteHashedFilename?: string;
  timelineSpriteFrameWidth?: number;
  timelineSpriteFrameHeight?: number;
  timelineSpriteNumSprites?: number;
  timelineSpriteFps?: number;
}

const VIDEO_LOOPING_GLOBAL_FLAG = true;

/**
 * Looping is disabled for background videos regardless of the global flag —
 * a bg video plays exactly once and its on-page span is clamped to one
 * playback pass. Non-background video items still loop when the global flag
 * is on.
 */
export function isVideoLoopingEnabledForItem(item: {isBackground: boolean}): boolean {
  return VIDEO_LOOPING_GLOBAL_FLAG && !item.isBackground;
}
